// extracted by mini-css-extract-plugin
export default {"pros":"Benifits_pros__Bl2Mc","heading":"Benifits_heading__liwqN","grid":"Benifits_grid__2DsjB","card":"Benifits_card__hek8Z","aaa":"Benifits_aaa__YMfxQ"};